import type { PropsWithChildren } from 'react'

export const SecaoDetalhesEmpreendimento = ({ titulo, children }: PropsWithChildren<{ titulo: string }>) => {
  return (
    <div className="grid gap-6">
      <h2 className="uppercase">{titulo}</h2>
      {children}
    </div>
  )
}
